import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { installAnalytics } from "./lib/analytics";
import { installSentry } from "./lib/sentry";
import "./styles.css";

installSentry();
installAnalytics();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
